import React, { useState, useEffect } from "react";
import AboutPageForm from "./AboutPageForm";
import AboutPageGrid from "./AboutPageGrid";
import ConfirmDialog from "../../../utils/ConfirmDialog";

const EditAboutPage = () => {
  const [data, setData] = useState([]);
  const [view, setView] = useState("grid");
  const [messages, setMessages] = useState({
    heading: "",
    para: "",
    imageurl: null,
  });
  const [editingId, setEditingId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const showData = () => {
    fetch("https://kvrstarlightmedicalacademy.com/api/founders.php")
      .then((response) => response.json())
      .then((data) => setData(data));
  };

  useEffect(() => {
    showData();
  }, []);

  const handleCreate = () => {
    setMessages({ heading: "", para: "", imageurl: null });
    setEditingId(null);
    setView("form");
  };

  const handleEdit = (id) => {
    const selected = data.find((item) => item.id === id);
    if (selected) {
      setMessages(selected);
      setEditingId(id);
      setView("form");
    }
  };

  const handleDelete = (id) => {
    setDeleteId(id);
  };

  const confirmDelete = async () => {
    try {
      const res = await fetch("https://kvrstarlightmedicalacademy.com/api/founders.php", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: deleteId }),
      });

      if (res.ok) {
        console.log("Deleted successfully");
      } else {
        console.error("Server error:", res.status);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    }
    setDeleteId(null);
    showData();
  };

  const cancelDelete = () => {
    setDeleteId(null);
  };

const handleFormSubmit = async (message) => {
  const formData = new FormData();
  formData.append("heading", message.heading);
  formData.append("para", message.para);
  if (message.imageurl instanceof File) {
    formData.append("image", message.imageurl); 
  }

  if (editingId) {
    formData.append("id", editingId);
  }

  try {
    const res = await fetch("https://kvrstarlightmedicalacademy.com/api/ounders.php", {
      method: "POST", 
      body: formData,
    });
    const result = await res.json();
    console.log("Server response:", result);
  } catch (err) {
    console.error("Fetch error:", err);
  }

  setMessages({ heading: "", para: "", imageurl: null });
  setView("grid");
  showData();
};

  return (
    <div className="container mt-4">
      {view === "grid" ? (
        <AboutPageGrid
          data={data}
          onCreate={handleCreate}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      ) : (
        <AboutPageForm
          onSubmit={handleFormSubmit}
          onCancel={() => setView("grid")}
          initialData={messages}
        />
      )}

      {deleteId !== null && (
        <ConfirmDialog
          message="Are you sure you want to delete this item?"
          onConfirm={confirmDelete}
          onCancel={cancelDelete}
        />
      )}
    </div>
  );
};

export default EditAboutPage;
